<template>
  <!-- TODO:CSSを共通処理に移動 -->
  <div class="error-background">
    <div class="error d-flex justify-content-center align-items-center">
      <PageNotFoundContent />
    </div>
  </div>
</template>

<script>
import PageNotFoundContent from "@/components/organisms/PageNotFoundContent.vue"
/**
 * 404 NOT FOUND URL 画面
 * ※コンポーネント名の先頭に数字は使用しない事
 */
export default {
  name: "PageNotFound",
  components: {
    PageNotFoundContent,
  },
}
</script>

<style lang="scss" scoped>
.error-background {
  height: 100%;
  background: #e9e9e9;
}

.error {
  max-width: 550px;
  height: 100%;
  margin: auto;
}
</style>
